module.exports = __webpack_public_path__ + "img/patrulla_gnacional_up_selected.dd00a374.svg";